<mat-icon style="font-size: 80px; width: 80px; height: 80px" color="warn"
  >error
</mat-icon>
<div class="text-warn text-center mt-[10px] w-full">
  {{ errorMessage }}
</div>
